import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$7 } from './box.js';
import { d as defineCustomElement$6 } from './form-field.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './toggle.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const expandableToggleCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host(:not([nested])){border:1px solid var(--jw-theme-surface-border-border-color)}:host(:not([nested])) .header{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-default-color)}:host(:not([nested])) .header-description{color:var(--jw-theme-surface-text-description-color)}:host(:not([nested])) wui-icon{margin-top:.25rem}:host(:not([nested])) h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem}:host(:not([nested])) .body{background-color:var(--jw-theme-surface-elevated-default-bg-color)}:host([nested]) .header{background-color:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .header-description{color:var(--jw-theme-surface-text-description-color)}:host([nested]) wui-icon{margin-top:.125rem}:host([nested]) h3{font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}:host([nested]) .body{background-color:var(--jw-theme-surface-level1-default-bg-color)}.header{border-radius:.375rem;gap:1rem;padding:1rem;transition:border-radius .35s ease,background-color .35s ease,color .35s ease}.header,.header-container{display:flex;flex-direction:column}.header-container{gap:.125rem}.header-description{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}wui-icon{align-self:flex-start}.title{gap:2rem;justify-content:space-between}.icon-title,.title{align-items:center;display:flex}.icon-title{flex:1;flex-direction:row;gap:.5rem}h3{margin:0;padding:0}.body{border-radius:.375rem;display:none;padding:1rem;transition:border-radius .35s ease}:host([checked]) .header{background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([checked]) .header:has(+.body){border-bottom-left-radius:0;border-bottom-right-radius:0}:host([checked]) .body{border-top-left-radius:0;border-top-right-radius:0;display:flex}:host([disabled]) .header{background-color:var(--jw-theme-neutral-muted-message-bg-color);color:var(--jw-theme-form-field-disabled-color);cursor:not-allowed}:host([disabled]) .header-description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}:host([disabled]) .description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}";
const WuiExpandableToggleStyle0 = expandableToggleCss;

const WuiExpandableToggle$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableToggle extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.checked = undefined;
        this.header = undefined;
        this.headerDescription = undefined;
        this.disabled = false;
        this.disabledMsg = undefined;
        this.iconName = undefined;
        this.nested = false;
    }
    toggle(checked = !this.checked) {
        if (this.disabled) {
            return;
        }
        this.checked = checked;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    render() {
        return (h(Host, { key: 'a4284294749ab65070244891dd772c5484d28877' }, h("div", { key: 'e6bc159a82f17e6c0b532f537a6fc33aa0df594c', class: "header" }, h("div", { key: '43be0ba40e92e88d337eb4c89a15e5f7f8fe4fc6', class: "title" }, h("div", { key: 'd74725740c723a60ba16d2b0abab49b9254fcff2', class: "icon-title" }, this.iconName && h("wui-icon", { key: '78b0489783288a42a237da261b59d833d0551c2f', name: this.iconName }), h("div", { key: 'e80e5fe7ae808783d97b099f1a6164ea620d4c73', class: "header-container" }, h("h3", { key: 'e039a2ae29aeb15e2e62abd23d8bbd558df18d5d' }, this.header), this.headerDescription && h("div", { key: '9a60c6abb6106b93a0c304cb1a206bb6f8166704', class: "header-description" }, this.headerDescription))), h("wui-toggle", { key: 'ce984b7e8113071d9903612706c73830ce27d6f3', onInput: (e) => {
                const target = e.currentTarget;
                // Emit our own event
                e.preventDefault();
                e.stopPropagation();
                this.toggle(target?.checked);
            }, checked: this.checked, disabled: Boolean(this.disabled), "data-test": "set-toggle-value" })), this.disabledMsg && (h("div", { key: 'ac5d841cc8a771a88ae7af5ba5a7d7f3fa6474dc', class: "description", "data-test": "show-toggle-disabled-warning" }, this.disabledMsg))), slotFilled(this.elm) && (h("div", { key: 'b92736355c09a37f8e59b7e75cf2edb517786e33', class: "body" }, h("slot", { key: '987c1d8c933387ff0d356318c9c0677df449e439' })))));
    }
    get elm() { return this; }
    static get style() { return WuiExpandableToggleStyle0; }
}, [1, "wui-expandable-toggle", {
        "checked": [1540],
        "header": [1],
        "headerDescription": [1, "header-description"],
        "disabled": [516],
        "disabledMsg": [1, "disabled-msg"],
        "iconName": [1, "icon-name"],
        "nested": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-toggle", "wui-box", "wui-form-field", "wui-icon", "wui-toggle", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-toggle":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableToggle$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-toggle":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableToggle = WuiExpandableToggle$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableToggle, defineCustomElement };

//# sourceMappingURL=wui-expandable-toggle.js.map